// SMS Configuration
export const SMS_SENDER_PHONE = '+1(440) 581.8253';
export const PATIENT_LINK_BASE_URL = 'https://forms.jotpsych.com';
export const SMS_COMPLIANCE_FOOTER = 'Reply STOP to unsubscribe; HELP for help';

export const getSmsBrandPrefix = (providerName: string): string =>
  `JotPsych on behalf of ${providerName}:`;

export const formatSmsPreview = (providerName: string, body: string): string =>
  `${getSmsBrandPrefix(providerName)} ${body}\n\n${SMS_COMPLIANCE_FOOTER}`;

export const buildOnboardingSmsPreview = (
  providerName: string,
  messageType: 'form' | 'reminder' | 'appointment',
): string => {
  const body =
    messageType === 'form'
      ? `You have a new form to complete. Please tap the link below to fill it out:\n\n${PATIENT_LINK_BASE_URL}/f/abc12`
      : `You have an upcoming appointment tomorrow at 2:00 PM. Please tap to confirm your appointment:\n\n${PATIENT_LINK_BASE_URL}/c/abc12`;

  return formatSmsPreview(providerName, body);
};
